module.exports = __webpack_public_path__ + "static/media/inventoryIcon.8cc5c62a.svg";